// Hooks de Administración · Enlaces compartidos (T-zhjj). Mismo endpoint
// que la pantalla de postventa (/share-bundles, endpoints/share-bundles.ts)
// bajo la clave de la sección, siguiendo el precedente de
// features/admin/queries.ts. Las mutaciones invalidan además la clave
// global `queryKeys.shareBundles`, para que la lista de postventa —que
// sigue viva en la misma sesión— no muestre un enlace ya revocado.
//
// El registro de accesos no se duplica: la pantalla reutiliza
// `useShareBundleAccesses` de lib/api/queries.ts tal cual.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ShareBundleCreateBody } from "@bitacorapro/api-types";
import { shareBundlesApi } from "../../../lib/api/endpoints/share-bundles";
import { queryKeys } from "../../../lib/api/queries";

export const enlacesQueryKeys = {
  list: ["administracion", "enlaces"] as const,
} as const;

export function useEnlaces() {
  return useQuery({
    queryKey: enlacesQueryKeys.list,
    queryFn: () => shareBundlesApi.list(),
  });
}

export function useCrearEnlace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ShareBundleCreateBody) => shareBundlesApi.create(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: enlacesQueryKeys.list });
      void qc.invalidateQueries({ queryKey: queryKeys.shareBundles });
    },
  });
}

export function useRevocarEnlace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => shareBundlesApi.revoke(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: enlacesQueryKeys.list });
      void qc.invalidateQueries({ queryKey: queryKeys.shareBundles });
    },
  });
}
